export enum LeasingStatusDocs {
  IN_REVIEW = 'IN_REVIEW',
  VALIDATED = 'VALIDATED',
  PENDING_UPLOAD = 'PENDING_UPLOAD'
}
